import React, { useState } from "react";
import { EmptyItem, Button } from "rhombus-react";
import { useDispatch, useSelector } from "react-redux";
import { isDVAST } from "utils/CreativeActions";
import { sendForAutoClassification as sendCreativeForAutoClassification } from "reducers/Creatives";
import { sendForAutoClassification as sendVersionForAutoClassification } from "reducers/CreativeVersions";
import { getCurrentCreativeAutoClassifiable, getCurrentVersionAutoClassifiable } from "selectors/Labels";

import "./NoLabelsView.css";

export default function NoLabelsView(props) {
	const { libraryId, creativeId, versionId, versionDetails } = props;
	const dispatch = useDispatch();
	const creativeDetails = useSelector(state => state.creativeDetails);
	const isCurrentItemAutoClassifiable = useSelector((state) => {
		if (versionId) {
			return getCurrentVersionAutoClassifiable(state, versionDetails);
		}

		return getCurrentCreativeAutoClassifiable(state);
	});
	const [isClassifying, setIsClassifying] = useState(false);

	const { autoClassificationStatus: versionAutoClassificationStatus  } = versionDetails || {};
	const { adType, autoClassificationStatus: creativeAutoClassificationStatus } = creativeDetails || {};

	const handleClick = () => {
		setIsClassifying(true);
		if (versionId) {
			dispatch(sendVersionForAutoClassification(creativeId, [versionId]))
				.then((resp) => {
					setIsClassifying(false);
				});

			return;
		}

		dispatch(sendCreativeForAutoClassification(libraryId, [creativeId]))
			.then((resp) => {
				setIsClassifying(false);
			});
	};

	let title = "No labels to display";
	let message = " "; // Initializing this value to avoid the default value string

	if (isDVAST(adType) && isCurrentItemAutoClassifiable) {
		message = "NOTE: This action on dynamic creatives will send all published versions for auto-classification.";
	}

	if (!versionId && (creativeAutoClassificationStatus === "In progress")
		|| versionId && (versionAutoClassificationStatus === "In progress")) {
		title = "Auto-classification is in progress.";
		message = "Please check back again in a little while.";
	}

	return (
		<EmptyItem
			className="no-labels"
			title={title}
			message={message}
			src="/images/noLabels.svg"
			buttons={isCurrentItemAutoClassifiable ? <Button onClick={handleClick} disabled={isClassifying}>Send for Auto-classification</Button> : null}
		/>)
	;
}
